import { ConfigSiteContext } from '@contexts/config-site'
import { useTrackNavigationLink } from '@hooks/use-track-navigation-link'
import { Link as GatsbyLink } from 'gatsby-link'
import React, { useContext } from 'react'

const Suggestions = () => {
  const { popularQuestionsRef } = useContext(ConfigSiteContext)
  const trackNavigation = useTrackNavigationLink()

  return (
    <div className="flex flex-col gap-6">
      <h3 className="text-075 text-amplification-black-premium/70 group-[.is-dark-mode]/menu:text-white-50/70 uppercase">
        Recherches suggérées
      </h3>
      <ul className="flex flex-col gap-6">
        {popularQuestionsRef.map(({ href, title }, i) => (
          <li key={i}>
            <GatsbyLink
              className="text-110 group-[.is-dark-mode]/menu:text-white-50 block h-full w-full text-[#232323] hover:opacity-60"
              to={href}
              onClick={trackNavigation}
            >
              {title}
            </GatsbyLink>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Suggestions
